// extracted by mini-css-extract-plugin
module.exports = {"page":"_2090","explain":"_3920","title":"_9826"};